jQuery(document).ready(function ($) {

    $('.sidebar-account-trigger').click(function () {
        let triggerElement = $('.sidebar-login');

        setTimeout(function () {
            if (triggerElement.hasClass('open')) {
                triggerElement.find('.input-text').on('input', function (e) {
                    let empty = true;
                    triggerElement.find('.input-text').each(function () {
                        if ($(this).val() != '') {
                            empty = false;
                        } else {
                            empty = true;
                        }
                    });

                    if (empty) {
                        triggerElement.find('.sc-button').addClass('states-disabled');
                    } else {
                        triggerElement.find('.sc-button').removeClass('states-disabled');
                    }
                });
            }
        }, 400);
    });

    $('#lost_pass_email').on('input', function (e) {
        let empty = true;
        if ($(this).val() != '') {
            empty = false;
        } else {
            empty = true;
        }

        if (empty) {
            $('.sc-button').addClass('states-disabled');
        } else {
            $('.sc-button').removeClass('states-disabled');
        }
    });

    $('#order_email').on('input', function (e) {
        let empty = true;
        if ($(this).val() != '') {
            empty = false;
        } else {
            empty = true;
        }

        if (empty) {
            $('.sc-button').addClass('states-disabled');
        } else {
            $('.sc-button').removeClass('states-disabled');
        }
    });

    // dev jorge
    const formState = {
        'manage-your-order': false,
        'manage-your-login': false,
    };

    const validateForm = (formHtml) => {
        let valid = true;
        let inputs = formHtml.find('input.required')

        // reset errors
        formHtml.find('.error-message').removeClass('block');

        // iterate all inputs
        inputs.each(function () {
            let item = jQuery(this);
            let value = jQuery(this).val().trim();

            // validate standar input "empty"
            if (value === '') {
                jQuery(item).closest('.input-group').find('.error-message').addClass('block')
                valid = false;
            }

            // validate input "email"
            if (jQuery(item).attr('type') === 'email') {
                const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (!regex.test(value)) {
                    jQuery(item).closest('.input-group').find('.error-message').addClass('block')
                    valid = false;
                }
            }

            // validate input type "password"
            if (jQuery(item).attr('type') === 'password') {
                if (value !== '' && value.length <= 7) {
                    jQuery(item).closest('.input-group').find('.error-message').addClass('block')
                    jQuery(item).closest('.input-group').find('.error-message').text(jQuery(item).attr('placeholder'))
                    valid = false;
                }
            }

            if (document.querySelector('.toggle-input[name="terms"]')) {
                if (jQuery('#sidebar-signup').hasClass('open')) {
                    if (!document.querySelector('.toggle-input[name="terms"]').checked) {
                        jQuery('.toggle-input[name="terms"]').closest('.toggle-group').find('.toggle-switch').css('background-color', 'var(--color-sc-color-destructive)');
                        valid = false;
                    } else {
                        jQuery('.toggle-input[name="terms"]').closest('.toggle-group').find('.toggle-switch').css('background-color', 'var(--color-black)');
                    }
                }
            }
        });
        return valid;
    }

    const handleYourOrder = (formId) => {
        const allText = Array.from(document.querySelectorAll('.order-input'))
            .map(item => item.value.trim())
            .join('');

        // validamos que al menos 2 inputs tengan datos
        if (document.querySelectorAll('.order-input')[1].value === '' ||
            document.querySelectorAll('.order-input')[2].value === '') {
            jQuery('.error-message-order').show();
            return false;
        }

        jQuery.ajax({
            url: translations.ajax_url,
            type: 'POST',
            data: { action: 'woocommerce_ajax_check_my_order', orderNum: allText },
            beforeSend: () => {
                jQuery('.error-message-order').hide();
                jQuery('.btn-send-my-order').hide();
                jQuery('.spinner-my-order').show();
            },
            complete: () => {
                jQuery('.btn-send-my-order').show();
                jQuery('.spinner-my-order').hide();
            },
            success: function (data) {

                const response = data.data;
                jQuery('.error-message-order').show();
                if (data.success) {
                    jQuery('.error-message-order').text(`* ${response.tracking_status}`);
                } else {
                    jQuery('.error-message-order').text(`* ${response.message}`);
                }
            },
            error: (e) => {
                console.log(e);
            }
        });
    }

    const handleYourLogin = (formId) => {
        const form = jQuery(`#${formId}`);
        formState[formId] = true;
        form.submit();
    };

    jQuery(document).on('submit', 'form.send-form', function (e) {

        const id = jQuery(this).attr('id');

        if (!formState[id]) {
            e.preventDefault();
            const $_form = jQuery(this);
            const isValid = validateForm($_form);
            if (!isValid) return false;
            $_form.trigger('form:validated', [id]);
        }
    });

    jQuery(document).on('form:validated', function (e, formId) {
        
        switch (formId) {
            case 'manage-your-order':
                handleYourOrder(formId);
                break;

            case 'manage-your-login':
                handleYourLogin(formId);
                break;
        }
    });

    // ==============================
    // === Lost password form validation ===  -- separamos responsabilidades por envio de formulario nativo
    // ==============================
    jQuery(document).on('submit', '.woocommerce-form-lost-password', function (e) {
        jQuery('.woocommerce-form-lost-password').find('.error-message').removeClass('block')
        if (jQuery('#lost_pass_email').val() === '') {
            jQuery(this).find('.error-message').addClass('block')
            e.preventDefault();
            return false;
        }
    })

    // ==============================
    // === Register form validation ===  -- separamos responsabilidades por envio de formulario nativo
    // ==============================
    jQuery(document).on('submit', '.woocommerce-form-register', function (e) {
        let form = jQuery(this);
        jQuery('.woocommerce-form-register').find('.error-message').removeClass('block')
        if (!validateForm(form)) {
            e.preventDefault();
            return false;
        }
    })

    jQuery(document).on('keypress', '#reg_password', function (e) {
        jQuery('.woocommerce-form-register__submit').attr('disabled', false)
        jQuery('.woocommerce-form-register__submit').css('cursor', 'pointer')
        jQuery('#customer_register .number-password').removeClass(`!text-sc-color-destructive`)
        jQuery(this).closest('.input-group').find('.error-message').hide()
        if (jQuery(this).val().length < 7) {
            jQuery('.woocommerce-form-register__submit').attr('disabled', true)
            jQuery('.woocommerce-form-register__submit').css('cursor', 'not-allowed')
            jQuery('#customer_register .number-password').addClass(`!text-sc-color-destructive`)
            jQuery(this).closest('.input-group').find('.error-message').show()
        }
        let longitud = jQuery(this).val().length + 1
        jQuery('#customer_register .number-password').text(`${longitud}/8`)
    })
});